<script>
import { defineComponent } from 'vue'
import TwListGroupItem from '@/components/generic/list-group/tw-list-group-item.vue'
import TwBadge from '@/components/generic/tw-badge.vue'
import TwButton from '@/components/generic/tw-button.vue'
import { useWebconnexIntegrationStore } from '@/stores/webconnexIntegration.js'

export default defineComponent({
  name: 'WebconnexIntegrationListGroupItem',
  components: { TwButton, TwBadge, TwListGroupItem },
  props: {
    webconnexIntegration: {
      type: Object,
      required: true
    },
    fundraiser: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      ValidationErrorMessage: null,
      LoadingEnablingDisabling: false,
      LoadingDeleting: false,
    }
  },
  methods: {
    async webconnexIntegrationEnable() {
      if(confirm('Are you sure you want to enable this integration?')) {
        try {
          this.ValidationErrorMessage = null
          this.LoadingEnablingDisabling = true
          await useWebconnexIntegrationStore().itemEnable(this.webconnexIntegration.id)
          this.LoadingEnablingDisabling = false
        } catch (e) {
          console.error(e)
          this.LoadingEnablingDisabling = false
          if (e.response) this.ValidationErrorMessage = e.response.data
          throw e
        }
      }
    },
    async webconnexIntegrationDisable() {
      if(confirm('Are you sure you want to disable this integration?')) {
        try {
          this.ValidationErrorMessage = null
          this.LoadingEnablingDisabling = true
          await useWebconnexIntegrationStore().itemDisable(this.webconnexIntegration.id)
          this.LoadingEnablingDisabling = false
        } catch (e) {
          console.error(e)
          this.LoadingEnablingDisabling = false
          if (e.response) this.ValidationErrorMessage = e.response.data
          throw e
        }
      }
    },
    async webconnexIntegrationDelete() {
      if(confirm('Are you sure you want to disable this integration?')) {
        try {
          this.ValidationErrorMessage = null
          this.LoadingDeleting = true
          await useWebconnexIntegrationStore().itemDelete(this.webconnexIntegration.id)
          this.LoadingDeleting = false
        } catch (e) {
          console.error(e)
          this.LoadingDeleting = false
          if (e.response) this.ValidationErrorMessage = e.response.data
          throw e
        }
      }
    }
  }
})
</script>

<template>
  <tw-list-group-item>
    <div class="float-right flex flex-row gap-2">
      <tw-button v-if="webconnexIntegration.enabled" :loading="LoadingEnablingDisabling" variant="primary" size="sm" @click="webconnexIntegrationDisable(webconnexIntegration)">
        Disable
      </tw-button>
      <tw-button v-else variant="primary" size="sm" :loading="LoadingEnablingDisabling" @click="webconnexIntegrationEnable(webconnexIntegration)">
        Enable
      </tw-button>

      <tw-button :loading="LoadingDeleting" variant="danger" size="sm" @click="webconnexIntegrationDelete(webconnexIntegration)">
        Delete
      </tw-button>
    </div>


    <tw-badge :variant="webconnexIntegration.enabled? 'green':'gray'">
      {{ webconnexIntegration.enabled? 'Enabled':'Disabled' }}
    </tw-badge>
    {{ webconnexIntegration.form_name }}
    <div>
      <div v-if="webconnexIntegration.type === 'supporter'" class="mt-2">
        Automatically creates a supporter page when a new participant is created in RedPodium.
      </div>
    </div>
  </tw-list-group-item>
</template>

<style scoped>

</style>
